const prefix = 'accountInfo';

export const LOAD = `${prefix}/LOAD`;
export const LOAD_SUCCESS = `${prefix}/LOAD_SUCCESS`;
export const LOAD_FAILED = `${prefix}/LOAD_FAILED`;
